import React, {Dispatch, Fragment} from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Button,
} from 'reactstrap';
import '../../sass/plan.scss';
import {LandingSitePlansContent} from '@integraciones_doc24/wehealthy-api/types/landing';
import {setPlan, setStepVisible, addStep} from '../../reducer/config-reducer';
import {connect} from 'react-redux';

interface configObject {
  configReducer: {
    planSeleccionado: string;
  };
}
interface contenido {
  content: LandingSitePlansContent;
  setPlan: Dispatch<string>;
  setStepVisible: Dispatch<string>;
  addStep: Dispatch<string>;
}

const Plan = (props: contenido) => {
  const {content} = props;
  const buttonEvent = (str: string, planSeleccionado: string) => {
    props.setPlan(planSeleccionado);
    props.setStepVisible('form');
    props.addStep('form');
  };
  const cantidadPlanes = content.plans.length;
  return (
    <Fragment>
      <Row>
        <Col md="8" className="mt-4">
          <Row className="text-center color-base">
            <h1 className="fw-bold">{content.title}</h1>
            <h3>{content.subTitle}</h3>
            <p>{content.briefText}</p>
          </Row>
          <Row className="mb-3">
            {content.plans.map((plan) => {
              return (
                <Col md={12 / cantidadPlanes} key={plan.id} className="mb-3">
                  <Card className="border-color-primary mb-2 background-base h-100">
                    <CardHeader className="background-primary color-text">
                      <CardTitle>{plan.title}</CardTitle>
                    </CardHeader>
                    <CardBody className='text-center color-text pb-4 d-flex flex-column justify-content-between"'>
                      <h5 className="pb-2">{plan.subTitle}</h5>
                      <div
                        className="text-start flex-fill"
                        dangerouslySetInnerHTML={{__html: plan.text}}
                      ></div>
                      {plan.button && (
                        <Button
                          className="background-secondary border-0 color-base p-3 ps-5 pe-5 fw-bold mt-4"
                          onClick={() => {
                            buttonEvent(plan.button?.action || '', plan.id);
                          }}
                        >
                          {' '}
                          {plan.button.label}
                        </Button>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>
    </Fragment>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    planSeleccionado: state.configReducer.planSeleccionado,
  };
};
export default connect(mapStateToProps, {setPlan, setStepVisible, addStep})(
  Plan,
);
